import * as TYPES from './mutationTypes'

export default {
  //服务配置list
  [TYPES.GET_SERVER_LIST](state, payload) {
    const { limit, offset,} = payload.result
    const total = payload.result.length
    Object.assign(state, {
      server_list: payload.result,
      server_paging: { limit, offset, total }
    })
  }
}
